export const MOCK_TT_TEMPLATE = {
            "label": "Time / Day",
            "time_label_list": [
                {
                    "label": "08:00 - 09:00"
                },
                {
                    "label": "09:00 - 10:00"
                },
                {
                    "label": "10:00 - 11:00"
                },
                {
                    "label": "11:00 - 12:00"
                },
                {
                    "label": "12:00 - 13:00"
                },
                {
                    "label": "13:00 - 14:00"
                },
                {
                    "label": "14:00 - 15:00"
                },
                {
                    "label": "15:00 - 16:00"
                }
            ],
            "day_list": [
                {
                    "label": "Monday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                },
                {
                    "label": "Tuesday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                },
                {
                    "label": "Wednesday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                },
                {
                    "label": "Thursday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                },
                {
                    "label": "Friday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                },
                {
                    "label": "Saturday",
                    "time_list": [
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": true
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        },
                        {
                            "break": false
                        }
                    ]
                }
            ]
        };
export const MOCK_TT_DATA = {
        "raw": [
            {
                "id": 0,
                "subject_component": {
                    "id": 25,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 11,
                    "manual": false
                },
                "classroom": {
                    "id": 10,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 7,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 1,
                "subject_component": {
                    "id": 24,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 3,
                    "manual": false
                },
                "classroom": {
                    "id": 10,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 2,
                "subject_component": {
                    "id": 24,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 3,
                    "manual": false
                },
                "classroom": {
                    "id": 10,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 3,
                "subject_component": {
                    "id": 24,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 3,
                    "manual": false
                },
                "classroom": {
                    "id": 10,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 4,
                "subject_component": {
                    "id": 27,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 7,
                    "manual": false
                },
                "classroom": {
                    "id": 9,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 6,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 5,
                "subject_component": {
                    "id": 26,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 6,
                "subject_component": {
                    "id": 26,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 7,
                "subject_component": {
                    "id": 26,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 5,
                    "end": 5,
                    "breaks": []
                }
            },
            {
                "id": 8,
                "subject_component": {
                    "id": 21,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 3,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 6,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 9,
                "subject_component": {
                    "id": 20,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 5,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 10,
                "subject_component": {
                    "id": 20,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 5,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 11,
                "subject_component": {
                    "id": 16,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 6,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 6,
                    "end": 6,
                    "breaks": []
                }
            },
            {
                "id": 12,
                "subject_component": {
                    "id": 16,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 6,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            },
            {
                "id": 13,
                "subject_component": {
                    "id": 16,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 6,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 14,
                "subject_component": {
                    "id": 13,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 4,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 15,
                "subject_component": {
                    "id": 13,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 4,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 6,
                    "end": 6,
                    "breaks": []
                }
            },
            {
                "id": 16,
                "subject_component": {
                    "id": 13,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 4,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 17,
                "subject_component": {
                    "id": 13,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 4,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 18,
                "subject_component": {
                    "id": 13,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 4,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            },
            {
                "id": 19,
                "subject_component": {
                    "id": 17,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 8,
                    "manual": false
                },
                "classroom": {
                    "id": 7,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 20,
                "subject_component": {
                    "id": 19,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 11,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 21,
                "subject_component": {
                    "id": 19,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 11,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            },
            {
                "id": 22,
                "subject_component": {
                    "id": 15,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 8,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 7,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 23,
                "subject_component": {
                    "id": 15,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 8,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            },
            {
                "id": 24,
                "subject_component": {
                    "id": 15,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 8,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 6,
                    "end": 6,
                    "breaks": []
                }
            },
            {
                "id": 25,
                "subject_component": {
                    "id": 18,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 5,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 5,
                    "end": 5,
                    "breaks": []
                }
            },
            {
                "id": 26,
                "subject_component": {
                    "id": 18,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 5,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 7,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 27,
                "subject_component": {
                    "id": 18,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 5,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 5,
                    "end": 5,
                    "breaks": []
                }
            },
            {
                "id": 28,
                "subject_component": {
                    "id": 12,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 5,
                    "end": 5,
                    "breaks": []
                }
            },
            {
                "id": 29,
                "subject_component": {
                    "id": 12,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 4,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 30,
                "subject_component": {
                    "id": 12,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 31,
                "subject_component": {
                    "id": 12,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 5,
                    "end": 5,
                    "breaks": []
                }
            },
            {
                "id": 32,
                "subject_component": {
                    "id": 12,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 9,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 2,
                    "start": 0,
                    "end": 0,
                    "breaks": []
                }
            },
            {
                "id": 33,
                "subject_component": {
                    "id": 23,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 7,
                    "manual": false
                },
                "classroom": {
                    "id": 8,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 3,
                    "start": 5,
                    "end": 6,
                    "breaks": []
                }
            },
            {
                "id": 34,
                "subject_component": {
                    "id": 22,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 5,
                    "start": 1,
                    "end": 1,
                    "breaks": []
                }
            },
            {
                "id": 35,
                "subject_component": {
                    "id": 22,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 0,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            },
            {
                "id": 36,
                "subject_component": {
                    "id": 22,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 10,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 3,
                    "end": 3,
                    "breaks": []
                }
            },
            {
                "id": 37,
                "subject_component": {
                    "id": 14,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 6,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 7,
                    "end": 7,
                    "breaks": []
                }
            },
            {
                "id": 38,
                "subject_component": {
                    "id": 14,
                    "manual": false
                },
                "student": {
                    "id": 3,
                    "manual": false
                },
                "teacher": {
                    "id": 6,
                    "manual": false
                },
                "classroom": {
                    "id": 5,
                    "manual": false
                },
                "time_slot": {
                    "manual": true,
                    "day": 1,
                    "start": 2,
                    "end": 2,
                    "breaks": []
                }
            }
        ],
        "unassigned": {
            "student": {
                "3": []
            },
            "teacher": {
                "11": [],
                "3": [],
                "7": [],
                "10": [],
                "9": [],
                "5": [],
                "6": [],
                "4": [],
                "8": []
            },
            "classroom": {
                "10": [],
                "9": [],
                "5": [],
                "3": [],
                "7": [],
                "8": []
            }
        },
        "student": {
            "3": [
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 30
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 20
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 35
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 2
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 25
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 4
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 16
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 13
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 38
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 36
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 7
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 24
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 37
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 32
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 3
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 12
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 19
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 27
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 15
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 0
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 9
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 14
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 23
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 5
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 33
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 26
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 29
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 17
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 21
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 6
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 28
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 11
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 22
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 1
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 34
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 18
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 10
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 31
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 8
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ]
            ]
        },
        "teacher": {
            "11": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 20
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 0
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 21
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "3": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 2
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 3
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 1
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "7": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 4
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 33
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "10": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 35
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 36
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 7
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 5
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 6
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 34
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "9": [
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 30
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 32
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 29
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 28
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 31
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 8
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ]
            ],
            "5": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 25
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 27
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 9
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 26
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 10
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "6": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 13
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 38
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 37
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 12
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 11
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "4": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 16
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 15
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 14
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 17
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 18
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "8": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 24
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 19
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 23
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 22
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ]
        },
        "classroom": {
            "10": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 2
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 3
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 0
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 1
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "9": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 4
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "5": [
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 30
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 20
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 35
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 25
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 16
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 13
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 38
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 36
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 7
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 24
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 37
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 32
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 12
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 27
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 15
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 9
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 14
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 23
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 5
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 26
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 29
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 17
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 21
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 6
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 28
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 11
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 22
                            }
                        ]
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 34
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 18
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 10
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 31
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "3": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 8
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    }
                ]
            ],
            "7": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 19
                            }
                        ]
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ],
            "8": [
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": [
                            {
                                "id": 33
                            }
                        ]
                    },
                    {
                        "tenancy": 1,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ],
                [
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    },
                    {
                        "tenancy": 0,
                        "tenant_list": []
                    }
                ]
            ]
        }
    };
export const MOCK_TT_RELATED_DATA = {
        "subject": {
            "16": {
                "id": 16,
                "label": "Biology",
                "code": "Biology",
                "color": "#F3E5F5"
            },
            "15": {
                "id": 15,
                "label": "Chemistry",
                "code": "Chemistry",
                "color": "#BBDEFB"
            },
            "13": {
                "id": 13,
                "label": "Computer Sc",
                "code": "Computer Sc",
                "color": "#C5CAE9"
            },
            "9": {
                "id": 9,
                "label": "EVS",
                "code": "EVS",
                "color": "#D1C4E9"
            },
            "6": {
                "id": 6,
                "label": "English",
                "code": "English",
                "color": "#B2EBF2"
            },
            "10": {
                "id": 10,
                "label": "Games",
                "code": "Games",
                "color": "#FFF9C4"
            },
            "12": {
                "id": 12,
                "label": "Geography",
                "code": "Geography",
                "color": "#FFCCBC"
            },
            "8": {
                "id": 8,
                "label": "Hindi",
                "code": "Hindi",
                "color": "#C8E6C9"
            },
            "11": {
                "id": 11,
                "label": "History",
                "code": "History",
                "color": "#B2DFDB"
            },
            "5": {
                "id": 5,
                "label": "Maths",
                "code": "Maths",
                "color": "#FFECB3"
            },
            "14": {
                "id": 14,
                "label": "Physics",
                "code": "Physics",
                "color": "#F0F4C3"
            },
            "7": {
                "id": 7,
                "label": "Sanskrit",
                "code": "Sanskrit",
                "color": "#F8BBD0"
            }
        },
        "subject_component_type": {
            "6": {
                "id": 6,
                "label": "Activity",
                "code": "Activity",
                "color": "#CA6F1E"
            },
            "5": {
                "id": 5,
                "label": "Lab",
                "code": "Lab",
                "color": "#8E44AD"
            },
            "4": {
                "id": 4,
                "label": "Lecture",
                "code": "Lecture",
                "color": "#28B463"
            }
        },
        "subject_component": {
            "17": {
                "id": 17,
                "label": "Games",
                "subject": 10,
                "subject_component_type": 6,
                "sessions_per_cycle": 1,
                "slots_per_session": 1,
                "classroom_type": 8
            },
            "21": {
                "id": 21,
                "label": "Computer Sc",
                "subject": 13,
                "subject_component_type": 5,
                "sessions_per_cycle": 1,
                "slots_per_session": 2,
                "classroom_type": 6
            },
            "23": {
                "id": 23,
                "label": "Physics",
                "subject": 14,
                "subject_component_type": 5,
                "sessions_per_cycle": 1,
                "slots_per_session": 2,
                "classroom_type": 9
            },
            "25": {
                "id": 25,
                "label": "Biology",
                "subject": 16,
                "subject_component_type": 5,
                "sessions_per_cycle": 1,
                "slots_per_session": 1,
                "classroom_type": 11
            },
            "27": {
                "id": 27,
                "label": "Chemistry",
                "subject": 15,
                "subject_component_type": 5,
                "sessions_per_cycle": 1,
                "slots_per_session": 2,
                "classroom_type": 10
            },
            "12": {
                "id": 12,
                "label": "Maths",
                "subject": 5,
                "subject_component_type": 4,
                "sessions_per_cycle": 5,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "13": {
                "id": 13,
                "label": "English",
                "subject": 6,
                "subject_component_type": 4,
                "sessions_per_cycle": 5,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "14": {
                "id": 14,
                "label": "Sanskrit",
                "subject": 7,
                "subject_component_type": 4,
                "sessions_per_cycle": 2,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "15": {
                "id": 15,
                "label": "Hindi",
                "subject": 8,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "16": {
                "id": 16,
                "label": "EVS",
                "subject": 9,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "18": {
                "id": 18,
                "label": "History",
                "subject": 11,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "19": {
                "id": 19,
                "label": "Geography",
                "subject": 12,
                "subject_component_type": 4,
                "sessions_per_cycle": 2,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "20": {
                "id": 20,
                "label": "Computer Sc",
                "subject": 13,
                "subject_component_type": 4,
                "sessions_per_cycle": 2,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "22": {
                "id": 22,
                "label": "Physics",
                "subject": 14,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 3
            },
            "24": {
                "id": 24,
                "label": "Biology",
                "subject": 16,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 11
            },
            "26": {
                "id": 26,
                "label": "Chemistry",
                "subject": 15,
                "subject_component_type": 4,
                "sessions_per_cycle": 3,
                "slots_per_session": 1,
                "classroom_type": 3
            }
        },
        "student": {
            "3": {
                "id": 3,
                "label": "Class 9",
                "code": "Class 9"
            }
        },
        "teacher": {
            "7": {
                "id": 7,
                "label": "DP Bakshi",
                "code": "DP Bakshi"
            },
            "5": {
                "id": 5,
                "label": "MK Reddy",
                "code": "MK Reddy"
            },
            "4": {
                "id": 4,
                "label": "Mr SK Joshi",
                "code": "Mr SK Joshi"
            },
            "3": {
                "id": 3,
                "label": "Ms Anjali",
                "code": "Ms Anjali"
            },
            "8": {
                "id": 8,
                "label": "Ms Preeti Sharma",
                "code": "Ms Preeti Sharma"
            },
            "11": {
                "id": 11,
                "label": "PT Rao",
                "code": "PT Rao"
            },
            "6": {
                "id": 6,
                "label": "SK Pandey",
                "code": "SK Pandey"
            },
            "9": {
                "id": 9,
                "label": "SP Gupta",
                "code": "SP Gupta"
            },
            "10": {
                "id": 10,
                "label": "VA Patel",
                "code": "VA Patel"
            }
        },
        "classroom": {
            "10": {
                "id": 10,
                "label": "BioLab",
                "code": "BioLab",
                "classroom_type": 11,
                "seating_capacity": 100
            },
            "9": {
                "id": 9,
                "label": "ChemLab",
                "code": "ChemLab",
                "classroom_type": 10,
                "seating_capacity": 100
            },
            "3": {
                "id": 3,
                "label": "Comp Lab",
                "code": "Comp Lab",
                "classroom_type": 6,
                "seating_capacity": 100
            },
            "7": {
                "id": 7,
                "label": "Games",
                "code": "Games",
                "classroom_type": 8,
                "seating_capacity": 100
            },
            "6": {
                "id": 6,
                "label": "Library",
                "code": "Library",
                "classroom_type": 5,
                "seating_capacity": 100
            },
            "8": {
                "id": 8,
                "label": "Physics",
                "code": "Physics",
                "classroom_type": 9,
                "seating_capacity": 100
            },
            "5": {
                "id": 5,
                "label": "Room 101",
                "code": "Room 101",
                "classroom_type": 3,
                "seating_capacity": 100
            },
            "4": {
                "id": 4,
                "label": "Sc Lab",
                "code": "Sc Lab",
                "classroom_type": 7,
                "seating_capacity": 100
            }
        }
    };

